import moment from "moment"
import { mealOptions, seatOptions, genderOptions } from "./constants"
import { useData } from "../contexts/DataContext"

export const useCalendarGenerator = () => {
    const { inventory } = useData()

    const generateCalendar = (departure, arrival, year, month) => {
        const startOfMonth = moment([year, month, 1])
        const daysInMonth = startOfMonth.daysInMonth()
        const firstDayIndex = startOfMonth.day()
        const today = moment().startOf("day")
        const calendarDays = []

        // Add blank days for padding before the first day of the current month
        for (let i = 0; i < firstDayIndex; i++) {
            calendarDays.push({ date: null })
        }

        let availableTickets = []
        availableTickets = inventory.filter(
            (item) => item.departure === departure && item.arrival === arrival
        )

        for (let day = 1; day <= daysInMonth; day++) {
            const currentDate = startOfMonth.clone().date(day)
            const formattedDate = currentDate.format("YYYY-MM-DD")
            const ticketsInfo = availableTickets.find((item) => item.departureDate === formattedDate) || null
            const isPast = currentDate.isBefore(today, "day")

            calendarDays.push({
                date: formattedDate,
                availableTickets: ticketsInfo?.availableTickets || 0,
                ticketPrice: ticketsInfo?.price || "",
                currency: "$",
                isPast: currentDate.isSame(today, "day") ? false : isPast,
            })
        }

        return calendarDays
    }

    return generateCalendar
}

const getFirstDateOfNextMonth = () => {
    let today = new Date()
    let nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
    nextMonth = moment(nextMonth).format("YYYY-MM-DD")
    return nextMonth
}

const calculateFlightDuration = (departureTime, arrivalTime) => {
    const parseTime = (timeStr) => {
        const [time, modifier] = timeStr.split(" ")
        let [hours, minutes] = time.split(":").map(Number)

        if (modifier === "(+1)") {
            hours += 24 // Adjust for next day arrival
        }
        return { hours, minutes }
    }
    const depTime = parseTime(departureTime)
    const arrTime = parseTime(arrivalTime)
    let durationHours = arrTime.hours - depTime.hours
    let durationMinutes = arrTime.minutes - depTime.minutes
    if (durationMinutes < 0) {
        durationMinutes += 60
        durationHours -= 1
    }

    return `${durationHours} hrs ${durationMinutes} mins`
}

const getMealValue = (meal) => {
    return mealOptions.find((item) => item.value === meal)?.label
}

const getSeatValue = (seat) => {
    return seatOptions.find((item) => item.value === seat)?.label
}

const getGenderValue = (gender) => {
    return genderOptions.find((item) => item.value === gender)?.label
}

export { getFirstDateOfNextMonth, calculateFlightDuration, getMealValue, getSeatValue, getGenderValue }
